export const vocabulary = {
    uk: {
        header: "Словник",
        title: "Практичне рішення для вивчення мови",
        mainText: "Ця сторінка допоможе вам запам’ятати 1 050 найуживаніших слів англійської мови. Оберіть свою сотню та десятку, а потім поставте галочки біля слів, які ви впевнено знаєте як англійською, так і українською.\nЗверніть увагу, що викладач має власні клітинки, у яких він ставитиме галочки під час перевірки ваших знань на заняттях.\nВідсоток у нижній частині панелі показує як ваш прогрес, так і прогрес, відмічений викладачем.",
        memorizingTitle: "Техніки запам’ятовування",
        selectHundred: "Виберіть сотню і десятку",
        studentPercent: "Учень",
        tutorPercent: "Репетитор",
        memorizingData: [
               {
        circleNumber: 1,
        circleHeading: "Повторення",
        circleText: "Повторюйте одне й те саме слово багато разів протягом кількох днів. Чим частіше ви його бачите, тим легше воно запам’ятовується."
    },
    {
        circleNumber: 2,
        circleHeading: "Контекст",
        circleText: "Вивчайте слово в реченні або невеликій історії, а не окремо. Це допоможе зрозуміти, як воно використовується в реальних ситуаціях."
    },
    {
        circleNumber: 3,
        circleHeading: "Відтворення",
        circleText: "Спробуйте пригадати слово, не дивлячись на нього. Наприклад, закрийте слово й перевірте, чи зможете відтворити його з пам’яті."
    },
    {
        circleNumber: 4,
        circleHeading: "Асоціація",
        circleText: "Пов’язуйте слово із зображенням, ідеєю або чимось особисто значущим для вас. Коли слово асоціюється з чимось важливим, воно запам’ятовується значно краще."
    },
    {
        circleNumber: 5,
        circleHeading: "Занурення",
        circleText: "Звертайте увагу на слово в різних контекстах — під час читання, аудіювання та спілкування. Чим частіше слово трапляється в реальному житті, тим швидше воно стає знайомим і зрозумілим."
    } 
        ]
    },
    en: {
        header: "Vocabulary",
        title: "A practical solution for learning a language",
        mainText: "This page will help you memorize the 1,050 most common words in the English language. Choose your hundred and your ten, then check the boxes for the words you confidently know in both English and Ukrainian. \n Please note that the teacher has their own checkboxes, which they will mark when testing your knowledge during the lessons. \n The percentage at the bottom of the panel shows both your progress and the progress marked by your teacher.",
        memorizingTitle: "Memorizing Techniques",
        selectHundred: "Select your hundred and your ten",
        studentPercent: "Student",
        tutorPercent: "Tutor",
        memorizingData: [
               {
        circleNumber: 1,
        circleHeading: "Repetition",
        circleText: "Repeat the same word many times over several days. The more often you see it, the easier it is to remember."
    },
    {
        circleNumber: 2,
        circleHeading: "Context",
        circleText: "Learn the word inside a sentence or story instead of alone. This helps you understand how it’s used in real situations."
    },
    {
        circleNumber: 3,
        circleHeading: "Recall",
        circleText: "Try to remember the word without looking at it. For example, cover the word and see if you can say it from memory."
    },
    {
        circleNumber: 4,
        circleHeading: "Association",
        circleText: "Connect the word to a picture, idea, or something personal. When you link it to something meaningful, it sticks better."
    },
    {
        circleNumber: 5,
        circleHeading: "Exposure",
        circleText: "See and hear the word in many places — reading, listening, talking. The more often you meet the word in real life, the faster it becomes familiar."
    } 
        ]
    }
}